import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const Tag: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path d="M3.979 6.098a1.5 1.5 0 1 0 2.12-2.12 1.5 1.5 0 0 0-2.12 2.12Z"></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.48 1.055A2.75 2.75 0 0 0 6.447.25L1.833.4a.75.75 0 0 0-.506.219l-.707.707a.75.75 0 0 0-.22.506L.251 6.446a2.75 2.75 0 0 0 .804 2.033l6.636 6.636a2.75 2.75 0 0 0 3.889 0l3.535-3.536a2.75 2.75 0 0 0 0-3.89L8.48 1.056Zm-1.985.695c.346-.011.68.121.924.365l6.636 6.636a1.25 1.25 0 0 1 0 1.767l-3.536 3.536a1.25 1.25 0 0 1-1.768 0L2.116 7.419a1.25 1.25 0 0 1-.365-.924l.139-4.318.288-.288 4.317-.14Z"
            ></path>
        </Icon>
    );
};
